export default "__VITE_ASSET__67010300__"